import crashesGraphs from '@/utils/templates/mobileTemplate/kpi.crashes.graphs.config';
import performanceGraphs from '@/utils/templates/mobileTemplate/kpi.performance.graphs.config';
import dashboardGraphs from '@/utils/templates/mobileTemplate/dashboard.graphs.config';
import usageGraphs from '@/utils/templates/mobileTemplate/kpi.usage.graphs.config';
const mm = {
  details: [
    crashesGraphs().lineCharts,
    crashesGraphs().areaCharts,
    crashesGraphs().areaChartsRight,
    crashesGraphs().areaChartsBottom,
    crashesGraphs().heatMaps,
  ],
  usage: [
    [usageGraphs().lineCharts[0], usageGraphs().lineCharts[1]],
    [usageGraphs().lineChartsRight[0]],
    [usageGraphs().areaCharts[0]],
    [usageGraphs().areaChartsRight[0], usageGraphs().areaChartsRight[1]],
  ],
  performance: [
    [
      performanceGraphs().lineCharts[0],
      performanceGraphs().lineCharts[1],
      performanceGraphs().lineCharts[2],
    ],
    [performanceGraphs().lineChartsRight[0]],
    [],
    [performanceGraphs().heatMaps],
  ],
  dashboardGauge: [dashboardGraphs.guageChart],
};
export default mm;
